import { gql, useMutation } from '@apollo/client'
import {
  Edit,
  ListButton,
  SaveButton,
  SimpleForm,
  Toolbar,
  TopToolbar,
  useNotify,
  useRecordContext,
  useRedirect,
} from 'react-admin'
import { UpsertUser } from '~/components'

// Sent directly rather than through the dataProvider, whose update path only
// knows Hasura's default naming (update_<table>); nhost names it updateUsers.
const UPDATE_USER = gql`
  mutation UpdateUser($id: uuid!, $set: users_set_input!) {
    updateUser(pk_columns: { id: $id }, _set: $set) {
      id
    }
  }
`

// Hashes in the database and ends the user's sessions (see
// public.crm_set_password).
const SET_PASSWORD = gql`
  mutation SetPassword($userId: uuid!, $password: String!) {
    crm_set_password(args: { user_id: $userId, password: $password }) {
      id
    }
  }
`

const UserName = (props) => {
  const record = useRecordContext(props)
  return <span>Benutzer: {record ? record.displayName || record.email : ''}</span>
}

const UserEditActions = () => (
  <TopToolbar>
    <ListButton label='ra.action.back' />
  </TopToolbar>
)

// Save only. A staff account is locked, not deleted: the audit trail
// (public.history) refers to it.
const UserToolbar = () => (
  <Toolbar>
    <SaveButton />
  </Toolbar>
)

const UserForm = () => {
  const record = useRecordContext()
  const notify = useNotify()
  const redirect = useRedirect()
  const [updateUser] = useMutation(UPDATE_USER)
  const [setPassword] = useMutation(SET_PASSWORD)

  const save = async ({ email, displayName, defaultRole, disabled, password }) => {
    try {
      await updateUser({
        variables: {
          id: record.id,
          set: { email, displayName, defaultRole, disabled: !!disabled },
        },
      })
      if (password) {
        await setPassword({ variables: { userId: record.id, password } })
      }
      notify('ra.notification.updated', { type: 'info', messageArgs: { smart_count: 1 } })
      redirect('list', 'users')
    } catch (e) {
      notify(e.message, { type: 'error' })
    }
  }

  return (
    <SimpleForm onSubmit={save} toolbar={<UserToolbar />}>
      <UpsertUser />
    </SimpleForm>
  )
}

export const UserEdit = (props) => (
  <Edit title={<UserName />} actions={<UserEditActions />} {...props}>
    <UserForm />
  </Edit>
)

export default UserEdit
